$(document).ready(function() {
      if($("body").hasClass("template-product-gift-card")){
            $('.template-product-gift-card fieldset .form__label__value, fieldset label span').each(function(){
            var amountText = $(this).text().trim();
            var amount = parseFloat(amountText.replace(/[^0-9.-]+/g, ''));
            if (!isNaN(amount)) {
            var formattedAmount = '₹' + amount.toLocaleString();
            $(this).text(formattedAmount);
            }
            });
            
            $('.variations label').on('click', function() {
            var denomination_price = $(this).find("span").text(); 
            setTimeout(function() {
            $(".gift-card-selected-var").text(denomination_price);
            }, 300);
            });
               
            const intervalId = setInterval(() => {
            const popupBackdrop = document.querySelector('.Rise-popup-backdrop');
            if (popupBackdrop && popupBackdrop.classList.contains('show')) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
            }));
            } 
            }, 100);
      }
});